import Stack from '@mui/material/Stack'
import styled from '@mui/material/styles/styled'

type Props = {
  lastChildBorder?: boolean
}

export const AppointmentStack = styled(Stack, {
  name: 'AppointmentStack',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== 'lastChildBorder',
})<Props>(({ theme, lastChildBorder }) => ({
  '> div:not(:last-child)': {
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '> div:last-child': lastChildBorder
    ? {
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
      }
    : {},
}))
